import React from "react";
import { pct } from "./formatters";

// ----- Plan distribution ---------------------------------------------
// All five tiers, shown with their marketing labels. `counts` is keyed by
// the stored subscription_tier; we fold legacy / marketing aliases into the
// canonical buckets so e.g. "hotel" counts as Business and "professional"
// as Pro (mirrors backend normalize_tier).
const TIERS = [
  { key: "free",       label: "Free",         color: "#94a3b8", aliases: ["free", "trial"] },
  { key: "starter",    label: "Starter",      color: "#0d9488", aliases: ["starter"] },
  { key: "pro",        label: "Professional", color: "#2563eb", aliases: ["pro", "professional"] },
  { key: "business",   label: "Hotel",        color: "#b45309", aliases: ["business", "hotel"] },
  { key: "enterprise", label: "Enterprise",   color: "#7e22ce", aliases: ["enterprise", "enterprise+"] },
];

export default function TierBar({ counts, total }) {
  if (!total) return <p className="muted">No tenants yet.</p>;

  // Normalize incoming counts to lowercase so aliases match.
  const c = {};
  Object.entries(counts || {}).forEach(([k, v]) => {
    const key = String(k).toLowerCase();
    c[key] = (c[key] || 0) + (Number(v) || 0);
  });

  const segments = TIERS.map((t) => ({
    ...t,
    n: t.aliases.reduce((s, a) => s + (c[a] || 0), 0),
  }));

  return (
    <div>
      <div style={{ display: "flex", height: 28, borderRadius: 6, overflow: "hidden", border: "1px solid var(--border)" }}>
        {segments.map((s) => (
          s.n > 0 && (
            <div
              key={s.key}
              title={`${s.label}: ${s.n} (${pct(s.n, total)}%)`}
              style={{ width: `${pct(s.n, total)}%`, background: s.color }}
            />
          )
        ))}
      </div>
      <div style={{ display: "flex", gap: 16, marginTop: 8, flexWrap: "wrap", fontSize: "0.9rem" }}>
        {segments.map((s) => (
          <div key={s.key} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ width: 12, height: 12, background: s.color, display: "inline-block", borderRadius: 2 }} />
            <span><b>{s.n}</b> {s.label} <span className="muted">({pct(s.n, total) || 0}%)</span></span>
          </div>
        ))}
      </div>
    </div>
  );
}
